import Api from './rest/TaskBindApi';

export default new Api();
